export const SET_USERS = 'userSearch/SET_USERS';

export const SET_USERS_APPEND = 'userSearch/SET_USERS_APPEND';

export const CLEAR_SEARCH = 'userSearch/CLEAR_SEARCH';
